import React from 'react'

export default function FloatingDock() {
  return (
    <>
      {/* Desktop Floating Dock (Right side) */}
      <div className="fixed right-0 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-1 md:flex">
        <a
          href="tel:22115514"
          className="group flex items-center justify-end bg-red-700 text-white pl-4 pr-3 py-3 shadow-lg transition-all duration-300 hover:bg-neutral-900 hover:pl-6"
        >
          <span className="max-w-0 overflow-hidden text-xs font-bold uppercase tracking-wider transition-all duration-300 group-hover:max-w-xs group-hover:mr-3 whitespace-nowrap">
            Ring op
          </span>
          <i className="fa-solid fa-phone text-lg" />
        </a>
        <a
          href="mailto:Hogm@hansenogmortensen.dk"
          className="group flex items-center justify-end bg-neutral-900 text-white pl-4 pr-3 py-3 shadow-lg transition-all duration-300 hover:bg-red-700 hover:pl-6"
        >
          <span className="max-w-0 overflow-hidden text-xs font-bold uppercase tracking-wider transition-all duration-300 group-hover:max-w-xs group-hover:mr-3 whitespace-nowrap">
            Send e-mail
          </span>
          <i className="fa-solid fa-envelope text-lg" />
        </a>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="fixed bottom-0 left-0 z-40 flex w-full border-t border-zinc-800 bg-neutral-950 md:hidden">
        <a
          href="tel:22115514"
          className="flex flex-1 items-center justify-center gap-2 bg-red-700 py-3 text-center text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-red-800"
        >
          <i className="fa-solid fa-phone" />
          Ring op
        </a>
        <a
          href="mailto:Hogm@hansenogmortensen.dk"
          className="flex flex-1 items-center justify-center gap-2 bg-neutral-900 py-3 text-center text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-neutral-800"
        >
          <i className="fa-solid fa-envelope" />
          E-mail
        </a>
      </div>
    </>
  )
}
